import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { BASE_URL } from "../../utils/constants";

export const getUsers = createAsyncThunk(
  "users/getUsers",
  async (_, thunkAPI) => {
    try {
      const state = thunkAPI.getState();
      // Получаем токен з localStorage или з состояния
      let token = localStorage.getItem('token');
      
      // Если токена нет в localStorage, пытаемся получить з состояния
      if (!token && state.user.currentUser) {
        token = state.user.currentUser.access_token;
      }
      
      if (!token) {
        throw new Error('Токен не знайдено');
      }
      
      const res = await axios.get(`${BASE_URL}/user/all`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      return res.data;
    } catch (err) {
      console.log('Помилка при отриманні користувачів:', err);
      return thunkAPI.rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const updateUser = createAsyncThunk(
  "users/updateUser",
  async ({ id, formData }, thunkAPI) => {
    try {
      const token = localStorage.getItem('token');
      if (!(formData instanceof FormData)) {
        return thunkAPI.rejectWithValue('Некоректні дані форми');
      }

      const res = await axios.post(`${BASE_URL}/user/${id}`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
        }
      });
      return res.data;
    } catch (err) {
      console.log('Помилка при оновленні користувача:', err);
      return thunkAPI.rejectWithValue(err.response?.data?.message || err.message);
    }
  }
);

export const deleteUser = createAsyncThunk(
  "users/deleteUser",
  async (id, thunkAPI) => {
    try {
      const token = localStorage.getItem('token');
      await axios.delete(`${BASE_URL}/user/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      return id;
    } catch (err) {
      console.log('Помилка при видаленні користувача:', err);
      return thunkAPI.rejectWithValue(err.response?.data?.message || err.message);
    }
  }
);

const usersSlice = createSlice({
  name: "users",
  initialState: {
    list: [],
    isLoading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getUsers.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getUsers.fulfilled, (state, action) => {
        state.isLoading = false;
        state.list = action.payload;
      })
      .addCase(getUsers.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(updateUser.fulfilled, (state, action) => {
        const index = state.list.findIndex(user => user.id === action.payload.id);
        if (index !== -1) {
          state.list[index] = action.payload;
        }
      })
      .addCase(deleteUser.fulfilled, (state, action) => {
        state.list = state.list.filter(user => user.id !== action.payload);
      });
  },
});

export default usersSlice.reducer;

